import { PureComponent } from 'react'
import ReactSelect from 'react-select'
import styled from 'glamorous'
import { css } from 'glamor'
import { $ } from 'utils'

require('react-select/dist/react-select.css')

const RSelect = styled(ReactSelect)({
  width: 100,
  zIndex: 10,
}, ({ width, bgColor = 'var(--bgColor)' }) => ({
  width,
  '.Select .Select-control, .Select .Select-input, .Select .Select-menu-outer, .Select-control .Select-input:focus': {
    backgroundColor: `${bgColor} !important`
  }
}))

// todo: need to think about custom dropdown list
export class Select extends PureComponent {
  
  render = () => $(RSelect, {...this.props})
}

// override of react-select styles
css.global('.Select .Select-control', {
  cursor: 'pointer',
  height: 34
})

css.global('.Select .Select-input', {
  height: 32,
})


export default Select



// WEBPACK FOOTER //
// ./src/components/Select.js